var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return !_vm.element.hideLabel ? _c('div', {
    staticClass: "res-label"
  }, [_c('div', {
    staticClass: "label-pre m-r-3",
    style: _vm.styleWidth,
    domProps: {
      "innerHTML": _vm._s(_vm.getLabelVal)
    }
  }), _vm.element.isLabelRemark ? _c('div', {
    staticClass: "label-remark"
  }, [_c('el-tooltip', _vm._b({
    attrs: {
      "content": _vm.content
    }
  }, 'el-tooltip', _vm.$attrs, false), [_c('i', {
    staticClass: "el-tooltip el-icon-question"
  })])], 1) : _vm._e()]) : _vm._e();
};

var staticRenderFns = [];
export { render, staticRenderFns };